<template>
	<div v-if="!isEmptyColumnData" class="layout-footer">
		<el-image :src="LAYOUT_FOOTER_BG" fit="cover" class="footer-bg" />
		<ContentPad>
			<div class="footer-block">
				<div class="footer-left">
					<div class="l-title">
						<!-- 自定义标题 -->
						<slot v-if="'title' in slots" name="title"></slot>
						<span v-else>{{ $t('enterprise.communication-and-connection') }}</span>
					</div>

					<!-- 自定义左侧内容 -->
					<slot v-if="'content-left' in slots" name="content-left"></slot>
					<template v-else>
						<div class="l-row">
							<div class="l-icon">
								<img :src="LAYOUT_PHONE_ICON" alt="" />
							</div>
							<div class="l-span">{{ getPhone || 'XXXXXXXXXXX' }}</div>
						</div>
						<div class="l-row">
							<div class="l-icon">
								<img :src="LAYOUT_EMAIL_ICON" alt="" />
							</div>
							<div class="l-span">{{ getEmail || 'XXXXXXXXXXXXXX' }}</div>
						</div>
						<div class="l-row">
							<div class="l-icon">
								<img :src="LAYOUT_REGION_ICON" alt="" />
							</div>
							<div class="l-span">
								{{ getAddressList?.[0]?.address || 'XXXXXXXXXXXXXXXX' }}
							</div>
						</div>
					</template>
				</div>

				<div v-if="getChannelList && getChannelList.length" class="footer-right">
					<!-- 自定义右侧内容 -->
					<slot v-if="'content-right' in slots" name="content-right"></slot>
					<template v-else>
						<div v-for="(item, index) in getChannelList" :key="index" class="channel-item">
							<div class="channel-image">
								<el-image :src="item.otherChannelImage" fit="cover" style="width: 100%; height: 100%" />
							</div>
							<div class="channel-value mt-14">{{ item.name }}</div>
						</div>
					</template>
				</div>
			</div>
		</ContentPad>
	</div>
</template>

<script setup>
import { useCommonData } from '@/hooks';
import { computed, useSlots } from 'vue';
import LAYOUT_FOOTER_BG from '@/assets/images/layout_footer_bg.png';
import LAYOUT_EMAIL_ICON from '@/assets/images/icon/email.png';
import LAYOUT_PHONE_ICON from '@/assets/images/icon/phonecall.png';
import LAYOUT_REGION_ICON from '@/assets/images/icon/region.png';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';

const slots = useSlots();

const { getAddressList, getPhone, getEmail, getChannelList } = useCommonData();
const isEmptyColumnData = computed(() => {
	const nonAddress =
		!getAddressList.value ||
		getAddressList.value.length === 0 ||
		getAddressList.value?.every(item => !item.address);
	const nonChannelList = !getChannelList.value || getChannelList.value.length === 0;
	// 全都没有的时候 隐藏底栏
	return !getPhone.value && !getEmail.value && nonAddress && nonChannelList;
});
</script>

<style lang="less" scoped>
.layout-footer {
	height: 275px;
	position: relative;

	.footer-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.footer-block {
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		position: relative;
	}
	.footer-left {
		.l-title {
			color: #fff;

			font-size: 24px;

			font-weight: 600;
			line-height: 150%; /* 36px */
			margin-top: 56px;
			margin-bottom: 40px;
		}
		.l-row {
			display: flex;

			& + .l-row {
				margin-top: 14px;
			}
		}
		.l-icon {
			height: 20px;
			display: flex;
			align-items: center;

			img {
				width: 18px;
				height: 18px;
			}
		}
		.l-span {
			margin-left: 8px;
			color: #fff;

			font-size: 14px;

			font-weight: 500;
			line-height: 20px;
			max-width: 580px;
		}
	}
	.footer-right {
		margin-top: 100px;
		display: flex;

		.channel-item {
			& + .channel-item {
				margin-left: 24px;
			}
			.channel-image {
				margin: 0 auto;
				width: 90px;
				height: 90px;
				background: #fff;
			}
			.channel-value {
				font-size: 12px;
				font-weight: 400;
				line-height: 17px;
				text-align: center;
				color: #ffffff;
			}
		}
	}
}
</style>
